<!-- Team -->
<section class="pb-5">
  <div class="container">
    <h5 class="section-title h1 pb-2" [ngClass]="layout.headerColor.colorText" style="text-align: center">SISTEMA DE
      FOLHA DE PAGAMENTO</h5>
    <h5 class="section-title h1 pb-2" [ngClass]="layout.headerColor.colorText" style="text-align: center">
      {{ entidade.razaoSocial }}</h5>
    <h5 class="h4 pb-2" [ngClass]="layout.headerColor.colorText" style="text-align: center">UNIDADE GESTORA</h5>
    <div class="row">
      <!-- Team member -->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let unidade of unidadesGestoras">
        <div (click)="setUnidade(unidade)" class="card pointer">
          <div class="card-body text-center">
            <p><i class="fas fa-bank fa-4x" [ngClass]="layout.btnColor.colorText" aria-hidden="true"></i></p>
            <h5 class="card-title" [ngClass]="layout.navColor.colorText">{{unidade.nome | reduzTexto:50 | uppercase}}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Team -->